var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knowledge-list-content"},[_c('KnowledgePublicTable',{attrs:{"directoryInfo":_vm.directoryInfo},on:{"onDetailShow":function($event){return _vm.$emit('onDetailShow', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }